import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom/client';
import { FeaturesProvider } from 'feature-toggle-jsx';
import ReactModal from 'react-modal';
import './common/css/index.css';
import './common/i18n/i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MemoryRouterProvider } from './providers/MemoryRouterContext';
import { FlowConfigProvider } from './providers/FlowConfigContext';
import getFeatureFlagsConfig from './features/featureToggles';
import { userAnalytics } from './services/analytics';
import { MetadataProvider } from './providers/MetadataContext';
import { AuthenticationProvider } from './providers/AuthenticationContext';

import initializeLogger from './common/logging/initializeLogger';
import { SignerProvider } from './providers/SignerContext';
import { GatekeeperNetworkServiceProvider } from './providers/GatekeeperNetworkService/GatekeeperNetworkServiceContext';
import { ThemeProvider } from './providers/theme/ThemeProvider';
import { FeesProvider } from './providers/FeesContext';

userAnalytics.initialize();
initializeLogger();

ReactModal.setAppElement('#root');
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const ConditionalStrictMode: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Disable strict mode if stage === e2e to prevent double - rendering of components
  const disableStrictMode =
    process.env.REACT_APP_DISABLE_STRICT_MODE ||
    ['e2e', 'preprod_e2e'].includes((process.env.REACT_APP_STAGE || 'unknown').toLowerCase());
  return disableStrictMode ? <>{children}</> : <React.StrictMode>{children}</React.StrictMode>;
};

root.render(
  <ConditionalStrictMode>
    <ThemeProvider>
      <MetadataProvider>
        <GatekeeperNetworkServiceProvider>
          <MemoryRouterProvider>
            <SignerProvider>
              <AuthenticationProvider>
                <FlowConfigProvider>
                  <FeesProvider>
                    <FeaturesProvider features={getFeatureFlagsConfig()}>
                      <App />
                    </FeaturesProvider>
                  </FeesProvider>
                </FlowConfigProvider>
              </AuthenticationProvider>
            </SignerProvider>
          </MemoryRouterProvider>
        </GatekeeperNetworkServiceProvider>
      </MetadataProvider>
    </ThemeProvider>
  </ConditionalStrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
